import { RoleFilterKeyString } from 'Attendances/types'
import { ROLE_FIELDS_INITIAL_VALUES } from '.'

export const ROLE_INITIAL_FILTER: RoleFilterKeyString = {
  search: '',
  ...ROLE_FIELDS_INITIAL_VALUES,
}
